import { render, staticRenderFns } from "./InputProtocolos.vue?vue&type=template&id=52015794&"
import script from "./InputProtocolos.vue?vue&type=script&lang=js&"
export * from "./InputProtocolos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports